import axios from '../helpers/api';
import db from './pouchDb';
import helper from '../helpers/custom/index';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { version } from './../../package.json';

export const teamService = {
    getAllTeams,
    getTeamsByUserId,
    getTeamsSimpleByTeamId,
    getTeamsSimpleByUserId,
    getTeamsSimpleBySalesTargetId,
    getTeamById,
    insertTeam,
    updateTeam,
    deleteTeam,
    createLocalTeam,
    getTeamTypes,
    getTeamAgents,
};

async function getTeamAgents() {
    try {
        const res = await axios.get(`/api/teams/agent-teams`);
        return res.data;
    }
    catch (error) {
        return error;
    }
}

async function getTeamTypes() {
    try {
        const res = await axios.get(`/api/teams/teamtypes`);
        return res.data;
    }
    catch (error) {
        return error;
    }
}

async function getAllTeams(page, size, sortField, sortOrder) {
    page = page || 1;
    size = size || 10000;
    sortField = sortField || 'dateCreated';
    sortOrder = sortOrder || 'DESC';

    try {
        const res = await axios.get(`/api/teams?page=${page}&size=${size}&sortField=${sortField}&sortOrder=${sortOrder}`);
        return res.data;
    } catch (error) {
        return error;
    }
}
/** Used by Cards */
async function getTeamsSimpleBySalesTargetId(id, page, size, sortField, sortValue, search) {
    page = page || 1;
    size = size || 10000;
    sortField = sortField || 'dateCreated';
    sortValue = sortValue || 'DESC';
    search = search || '%%';

    try {
        const res = await axios.get(
            `/api/teams/by-sales-target-simple/${id}?page=${page}&size=${size}&sortField=${sortField}&sortValue=${sortValue}&search=${search}`,
        );
        return res.data;
    } catch (error) {
        return error;
    }
}
/** Used by Cards */
async function getTeamsSimpleByUserId(page, size, sortField, sortValue, search) {
    page = page || 1;
    size = size || 10000;
    sortField = sortField || 'dateCreated';
    sortValue = sortValue || 'DESC';
    search = search || '%%';

    try {
        const res = await axios.get(
            `/api/teams/by-user-simple/?page=${page}&size=${size}&sortField=${sortField}&sortValue=${sortValue}&search=${search}`,
        );
        return res.data;
    } catch (error) {
        return error;
    }
}
/** Used by Cards */
async function getTeamsSimpleByTeamId(teamId, page, size, sortField, sortValue, search) {
    page = page || 1;
    size = size || 10000;
    sortField = sortField || 'dateCreated';
    sortValue = sortValue || 'DESC';
    search = search || '%%';

    try {
        const res = await axios.get(
            `/api/teams/by-team-simple//${teamId}?page=${page}&size=${size}&sortField=${sortField}&sortValue=${sortValue}&search=${search}`,
        );
        return res.data;
    } catch (error) {
        return error;
    }
}

async function getTeamsByUserId(page, size, sortField, sortValue, search) {
    page = page || 1;
    size = size || 10000;
    sortField = sortField || 'dateCreated';
    sortValue = sortValue || 'DESC';
    search = search || '%%';



    if (navigator.onLine) {
        try {
            const res = await axios.get(
                `/api/teams/by-user?page=${page}&size=${size}&sortField=${sortField}&sortValue=${sortValue}&search=${search}`,
            );
            return res.data;
        } catch (error) {
            return error;
        }
    } else {
        if (!db.userDB || _.isEmpty(db.userDB)) {
            db.userDB = await db.refreshUserDb();
        }
        const res = await db.userDB.allDocs({
            include_docs: true,
        });

        let teams = [];
        for (let i = 0; i < res.rows.length; i++) {
            let obj = res.rows[i].doc;
            if (obj && obj.team) {
                teams.push(obj.team);
            }
        }


        let pageNumber = page;
        const pageSize = size;

        const pages = Math.ceil(teams.length / size);
        if (pageNumber > pages) {
            pageNumber = pages;
        }
        const start = (pageNumber - 1) * pageSize;
        const end = start + pageSize;
        let total = teams.length;

        if (teams.length > 0) {
            teams = _.slice(teams, start, end);
        }

        let response = {
            result: {
                success: true,
                message: 'Teams retrieved successfully.',
            },
            data: {
                teams: teams,
            },
            meta: {
                paging: {
                    pageNumber,
                    pageSize: size,
                    total: total,
                },
            },
        }

        return response;
    }
}

async function getTeamById(id) {


    if (navigator.onLine) {
        try {
            const res = await axios.get(`/api/teams/${id}`);
            return res.data;
        } catch (error) {
            return error;
        }
    } else {
        if (!db.userDB || _.isEmpty(db.userDB)) {
            db.userDB = await db.refreshUserDb();
        }
        const res = await db.userDB.allDocs({
            include_docs: true,
        });
        let response = {
            result: {
                success: true,
                message: 'Successfully retrieved team and agents.',
            },
            data: {
                agents: [],
                team: {},
            },
        };
        for (let i = 0; i < res.rows.length; i++) {
            let obj = res.rows[i].doc;
            if (obj && obj.team && obj.team.Id == id) {
                response.data.team = obj.team;
                for (let j = 0; j < obj.team.teamMembers.length; j++) {
                    response.data.agents.push({
                        Id: '',
                        userId: obj.team.teamMembers[j],
                    });
                }
            }
        }
        return response;
    }
}

async function insertTeam(data) {
    try {
        data['Id'] = helper.checkId(data.Id) ? data.Id : uuidv4();
        if (navigator.onLine) {
            const res = await axios.post('/api/teams/', data);
            return res.data;
        } else {
            if (!db.userDB || _.isEmpty(db.userDB)) {
                db.userDB = await db.refreshUserDb();
            }
            await db.userDB.put({
                _id: data.Id,
                from: 'offline',
                team: data,
            });

            let changeId = uuidv4();
            await db.globalsDB.put({
                _id: changeId,
                change: {
                    version: version,
                    entityId: data.Id,
                    entityType: 'team',
                    userId: helper.getUserId(),
                    dateModified: DateTime.now().toISO(),
                    changeType: 'INSERT',
                },
            });
        }
    } catch (error) {
        return error;
    }
}

async function updateTeam(data) {
    try {
        if (navigator.onLine) {
            const res = await axios.put(`/api/teams/${data.Id}`, data);
            return res.data;
        } else {
            if (!db.userDB || _.isEmpty(db.userDB)) {
                db.userDB = await db.refreshUserDb();
            }
            const doc = await db.userDB.get(data.Id);
            await db.userDB.put({
                _id: data.Id,
                _rev: doc._rev,
                from: 'offline',
                team: data,
            });

            let changeId = uuidv4();
            await db.globalsDB.put({
                _id: changeId,
                change: {
                    version: version,
                    entityId: data.Id,
                    entityType: 'team',
                    userId: helper.getUserId(),
                    dateModified: DateTime.now().toISO(),
                    changeType: 'update',
                },
            });
        }
    } catch (error) {
        return error;
    }
}

async function deleteTeam(salesTeams) {
    try {
        if (navigator.onLine) {
            const res = await axios.delete('/api/teams/delete/', {
                data: { salesTeams: salesTeams },
            });
            return res.data;
        } else {
            if (!db.userDB || _.isEmpty(db.userDB)) {
                db.userDB = await db.refreshUserDb();
            }
            salesTeams.forEach(async salesTeam => {
                const doc = await db.userDB.get(salesTeam);
                await db.userDB.remove(doc);
                let changeId = uuidv4();
                await db.globalsDB.put({
                    _id: changeId,
                    change: {
                        version: version,
                        entityId: salesTeam,
                        entityType: 'team',
                        userId: helper.getUserId(),
                        dateModified: DateTime.now().toISO(),
                        changeType: 'delete',
                    },
                });
            });
        }
    } catch (error) {
        return error;
    }
}

async function createLocalTeam(modelId, versionId, data) {
    return db.post({
        model: { modelId: modelId, versiondId: versionId },
        data: data,
    });
}
